function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "80%",
  y1: "0%",
  x2: "20%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E95D26",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C02227",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Izv\\u0113lies-savu-instruktoru-(Karti\\u0146as)",
  transform: "translate(-318.000000, -464.000000)",
  fill: "url(#linearGradient-1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Page-content",
  transform: "translate(294.000000, 136.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Details",
  transform: "translate(24.000000, 322.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(0.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,0 C18.1570953,0 23.2311382,4.6370981 23.9202997,10.6094652 C23.9547377,10.6899717 23.9786807,10.7756674 23.9908163,10.864546 L24,11 L24,12 L24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 L0.003,11.71 L0,11.5939006 L0,11 C0,10.8626605 0.028043307,10.7302249 0.0795070045,10.6091257 C0.768861787,4.6370981 5.84290475,0 12,0 Z M2.56830693,15.3290445 L2.61538011,15.4616853 C3.86702434,18.8537294 6.9051872,21.3807232 10.5883358,21.9011338 C9.35380811,18.7646169 6.94506825,16.665723 3.2911156,15.5537093 L2.921567,15.4457956 L2.72465632,15.3852012 L2.56830693,15.3290445 L2.56830693,15.3290445 Z M21.4325741,15.3288226 L21.2753332,15.3852052 L20.7175921,15.5510618 C17.0587573,16.6623888 14.6471481,18.7620853 13.4109075,21.899832 C17.1421919,21.3744152 20.2118303,18.7879307 21.4325741,15.3288226 Z M15.8257386,9.64189409 C13.4676819,8.84872956 10.9246286,8.80907134 8.54807226,9.52291941 L8.17426139,9.64189409 L2.004,11.716 L2.00612937,11.7509606 C2.06303066,12.4777178 2.51170297,13.1127119 3.16755556,13.4125716 L3.31119926,13.4716089 L3.46078159,13.5198549 C7.26073211,14.5837448 10.0182486,16.6067309 11.6840242,19.5547235 L11.8583203,19.8741179 L12,20.15 L12.1416788,19.8741197 C13.6778302,16.9580127 16.2375905,14.9066484 19.7763059,13.7509005 L20.1735228,13.6261713 L20.5392135,13.5198563 C21.3520989,13.2922735 21.928831,12.5815508 21.993869,11.7509677 L21.995,11.716 L15.8257386,9.64189409 Z M12,11 C13.1045695,11 14,11.8954305 14,13 C14,14.1045695 13.1045695,15 12,15 C10.8954305,15 10,14.1045695 10,13 C10,11.8954305 10.8954305,11 12,11 Z M12,2 C7.33949882,2 3.42363389,5.18816676 2.31439892,9.50250656 L7.53663829,7.74625784 C10.3065905,6.81454665 13.2953455,6.77403747 16.0843241,7.62473029 L16.4633617,7.74625784 L21.6856011,9.50250656 C20.5763661,5.18816676 16.6605012,2 12,2 Z",
  id: "icon"
}))))));

function SvgIcInstructorsCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8ED4468C-615C-410D-B322-B0E12FB90311") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstructorsCar);
export default __webpack_public_path__ + "static/media/ic-instructors-car.cefeb3e2.svg";
export { ForwardRef as ReactComponent };